import Vue from "vue";
import authHeader from '../../util/auth-header'

export default {
    list: (page = 1) => {
        return Vue.http.get(`users?page=${page}`).then((response) => {
            return response.body
        })
    },
    listActiveBranches: () => {
        return Vue.http.get("branches/actives", { headers: authHeader() }).then((response) => {
            return response.body
        })
    },
    listActiveIndicators: () => {
        return Vue.http.get("indicators/actives", { headers: authHeader() }).then((response) => {
            return response.body
        })
    },
    new: (branch) => {
        return Vue.http.post("users", branch, { headers: authHeader() }).then((response) => {
            return response.status
        })
    },
    edit: (branch, id) => {
        return Vue.http.put(`users/${id}`, branch, { headers: authHeader() }).then((response) => {
            return response.status
        })
    },
    delete: (id) => {
        return Vue.http.delete(`users/${id}`, { headers: authHeader() }).then((response) => {
            return response.status
        })
    },
    updateStatus: (id) => {
        return Vue.http.patch(`users/${id}`, { headers: authHeader() }).then((response) => {
            return response.status
        })
    },
    me: () => {
        return Vue.http.get(`users/me`).then((response) => {
            return response.body
        })
    },
    branchesByUser: (id) => {
        return Vue.http.get(`users/branches/${id}`).then(response => {
            return response.body
        })
    }
}
